var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 4.40967C16.1166 4.25149 16.3312 4.16263 16.5549 4.16263C16.7787 4.16263 16.9932 4.25149 17.1515 4.40967L19.6057 6.86385C19.7638 7.02208 19.8527 7.23665 19.8527 7.46039C19.8527 7.68412 19.7638 7.89869 19.6057 8.05692L8.32359 19.3395L4.67578 15.6917L15.9584 4.40967Z",
    fill: "url(#paint0_radial_346_3136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 4.40967C16.1166 4.25149 16.3312 4.16263 16.5549 4.16263C16.7787 4.16263 16.9932 4.25149 17.1515 4.40967L19.6057 6.86385C19.7638 7.02208 19.8527 7.23665 19.8527 7.46039C19.8527 7.68412 19.7638 7.89869 19.6057 8.05692L8.32359 19.3395L4.67578 15.6917L15.9584 4.40967Z",
    fill: "url(#paint1_linear_346_3136)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 4.40967C16.1166 4.25149 16.3312 4.16263 16.5549 4.16263C16.7787 4.16263 16.9932 4.25149 17.1515 4.40967L19.6057 6.86385C19.7638 7.02208 19.8527 7.23665 19.8527 7.46039C19.8527 7.68412 19.7638 7.89869 19.6057 8.05692L8.32359 19.3395L4.67578 15.6917L15.9584 4.40967Z",
    fill: "url(#paint2_linear_346_3136)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 4.40967C16.1166 4.25149 16.3312 4.16263 16.5549 4.16263C16.7787 4.16263 16.9932 4.25149 17.1515 4.40967L19.6057 6.86385C19.7638 7.02208 19.8527 7.23665 19.8527 7.46039C19.8527 7.68412 19.7638 7.89869 19.6057 8.05692L8.32359 19.3395L4.67578 15.6917L15.9584 4.40967Z",
    fill: "url(#paint3_radial_346_3136)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14406 19.7524C4.14248 19.7689 4.14459 19.7856 4.15023 19.8012C4.15587 19.8169 4.16491 19.8311 4.17669 19.8428C4.18847 19.8545 4.2027 19.8635 4.21836 19.869C4.23401 19.8746 4.25071 19.8766 4.26725 19.875L7.946 19.5212C8.05209 19.5111 8.15313 19.4711 8.23738 19.4059L8.32344 19.3395L4.67619 15.6917L4.61938 15.7603C4.54775 15.8472 4.50385 15.9536 4.49338 16.0657L4.14406 19.7524Z",
    fill: "url(#paint4_linear_346_3136)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14406 19.7524C4.14248 19.7689 4.14459 19.7856 4.15023 19.8012C4.15587 19.8169 4.16491 19.8311 4.17669 19.8428C4.18847 19.8545 4.2027 19.8635 4.21836 19.869C4.23401 19.8746 4.25071 19.8766 4.26725 19.875L7.946 19.5212C8.05209 19.5111 8.15313 19.4711 8.23738 19.4059L8.32344 19.3395L4.67619 15.6917L4.61938 15.7603C4.54775 15.8472 4.50385 15.9536 4.49338 16.0657L4.14406 19.7524Z",
    fill: "url(#paint5_linear_346_3136)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14406 19.7524C4.14248 19.7689 4.14459 19.7856 4.15023 19.8012C4.15587 19.8169 4.16491 19.8311 4.17669 19.8428C4.18847 19.8545 4.2027 19.8635 4.21836 19.869C4.23401 19.8746 4.25071 19.8766 4.26725 19.875L7.946 19.5212C8.05209 19.5111 8.15313 19.4711 8.23738 19.4059L8.32344 19.3395L4.67619 15.6917L4.61938 15.7603C4.54775 15.8472 4.50385 15.9536 4.49338 16.0657L4.14406 19.7524Z",
    fill: "url(#paint6_linear_346_3136)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8163 9.84679L19.6051 8.05692C19.7633 7.89869 19.8521 7.68412 19.8521 7.46039C19.8521 7.23665 19.7633 7.02208 19.6051 6.86385L17.1509 4.40967C16.9927 4.25149 16.7781 4.16263 16.5544 4.16263C16.3306 4.16263 16.1161 4.25149 15.9578 4.40967L14.168 6.19954L17.8163 9.84679Z",
    fill: "url(#paint7_linear_346_3136)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8163 9.84679L19.6051 8.05692C19.7633 7.89869 19.8521 7.68412 19.8521 7.46039C19.8521 7.23665 19.7633 7.02208 19.6051 6.86385L17.1509 4.40967C16.9927 4.25149 16.7781 4.16263 16.5544 4.16263C16.3306 4.16263 16.1161 4.25149 15.9578 4.40967L14.168 6.19954L17.8163 9.84679Z",
    fill: "url(#paint8_linear_346_3136)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8163 9.84679L19.6051 8.05692C19.7633 7.89869 19.8521 7.68412 19.8521 7.46039C19.8521 7.23665 19.7633 7.02208 19.6051 6.86385L17.1509 4.40967C16.9927 4.25149 16.7781 4.16263 16.5544 4.16263C16.3306 4.16263 16.1161 4.25149 15.9578 4.40967L14.168 6.19954L17.8163 9.84679Z",
    fill: "url(#paint9_radial_346_3136)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.99332L14.1694 6.19894L17.8166 9.84676L16.0222 11.6411L12.375 7.99332Z",
    fill: "url(#paint10_linear_346_3136)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.99332L14.1694 6.19894L17.8166 9.84676L16.0222 11.6411L12.375 7.99332Z",
    fill: "url(#paint11_linear_346_3136)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26725 19.8751C4.25071 19.8768 4.23401 19.8747 4.21836 19.8692C4.2027 19.8636 4.18847 19.8546 4.17669 19.8429C4.16491 19.8312 4.15587 19.817 4.15023 19.8014C4.14459 19.7857 4.14248 19.769 4.14406 19.7525L4.26669 18.4587L5.55819 19.7508L4.26725 19.8751Z",
    fill: "url(#paint12_linear_346_3136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_346_3136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.48703 17.625) rotate(-45.6437) scale(11.063 6.86239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3633D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_3136",
    x1: 8.70159,
    y1: 11.3672,
    x2: 9.58078,
    y2: 12.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9B6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_3136",
    x1: 14.6084,
    y1: 13.4063,
    x2: 13.5537,
    y2: 12.5277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E66A62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_346_3136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.34641 17.5199) rotate(-44.8606) scale(10.2172 2.28474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF994D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF994D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_346_3136",
    x1: 5.18638,
    y1: 17.6779,
    x2: 6.66294,
    y2: 19.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7A98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_346_3136",
    x1: 6.92619,
    y1: 17.7836,
    x2: 6.632,
    y2: 18.0817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#FFC09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_346_3136",
    x1: 3.85044,
    y1: 17.5896,
    x2: 5.04575,
    y2: 17.6953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBCA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_346_3136",
    x1: 18.7917,
    y1: 5.77767,
    x2: 16.4714,
    y2: 8.06254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_346_3136",
    x1: 14.6787,
    y1: 5.56673,
    x2: 16.5068,
    y2: 7.25423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1553E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1553E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_346_3136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3167 6.30481) rotate(135) scale(0.770636 1.75065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FF786D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_346_3136",
    x1: 13.3076,
    y1: 7.14844,
    x2: 15.6279,
    y2: 9.25782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_346_3136",
    x1: 16.9639,
    y1: 11.0859,
    x2: 15.6634,
    y2: 9.82032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9B9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B9E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_346_3136",
    x1: 4.25431,
    y1: 19.0488,
    x2: 4.85113,
    y2: 19.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450F51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b8168f18748ac133225cc8fb6ef6f110.svg";
export { ForwardRef as ReactComponent };